import React, {useEffect, useState} from 'react'
import actions from 'redux-auto'
import ChatList from '#components/m/Chat/ChatList'
import ChatDetail from '#components/m/Chat/ChatDetail'
import Api from '#services/api'
import {useMyChats} from '#hooks/useMyChats'

function ChatMasterDetail() {
  const {chats} = useMyChats()
  const [selectedChatId, setSelectedChatId] = useState(Object.keys(chats)[0])
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    actions.chat.getActivities({chatId: selectedChatId})
  }, [selectedChatId])

  const submitMessage = async msg => {
    const trimmedMessage = msg.trim()
    if (trimmedMessage.length === 0) {
      return false
    }

    try {
      setIsSubmitting(true)
      await Api.createChatActivity(selectedChatId, {displayMessage: trimmedMessage})
      return true
    } catch (e) {
      actions.error.writeError({error: e})
      return false
    } finally {
      setIsSubmitting(false)
    }
  }

  const selectedChat = chats[selectedChatId]

  return (
    <div className="chat--master-detail">
      <ChatList chatIds={Object.keys(chats)} onSelectChat={setSelectedChatId} selectedChatId={selectedChatId} />
      <ChatDetail chat={selectedChat} submitMessage={submitMessage} isSubmitting={isSubmitting} />
    </div>
  )
}

ChatMasterDetail.propTypes = {}

export default ChatMasterDetail
